<template>
  <div v-if="addQuestionTemplate === 'default'">
    <span
      :style="{
        color: textColor || '#000000',
      }"
      >{{ questionText }}</span
    >
    <div
      class="contact-question"
      v-for="(contact, index) in choices"
      :key="index"
    >
      <label
        style="margin-right: 30px"
        :style="{
          color: textColor || '#000000',
        }"
        >{{ formatContact(contact) }}</label
      >

      <template v-if="contact === 'name'">
        <div class="answer">
          <input
            :style="{
              color: textColor || '#000000',
            }"
            type="text"
            ref="contactName"
            placeholder="Ex: Paulo Silva"
            @input="update()"
            class="answer-text"
          />
        </div>
      </template>

      <template v-if="contact === 'email'">
        <div class="answer">
          <input
            :style="{
              color: textColor || '#000000',
            }"
            type="email"
            ref="contactEmail"
            placeholder="Ex: nome@email.com"
            @input="update()"
            class="answer-text"
          />
        </div>
      </template>

      <template v-if="contact === 'phone'">
        <div class="answer">
          <input
            :style="{
              color: textColor || '#000000',
            }"
            type="text"
            ref="contactPhone"
            placeholder="(19)-99999999"
            v-mask="'(##)-#########'"
            v-model="phoneNumber"
            @input="update()"
            class="answer-text"
          />
        </div>
      </template>
    </div>
  </div>

  <div v-else>
    <div
      class="align-center"
      :style="{
        color: textColor || '#000000',
      }"
    >
      {{ questionText }}
    </div>
    <div
      class="align-center contact-question"
      v-for="(contact, index) in choices"
      :key="index"
    >
      <label
        style="margin-right: 30px"
        :style="{
          color: textColor || '#000000',
        }"
        >{{ formatContact(contact) }}</label
      >

      <template v-if="contact === 'name'">
        <div class="answer">
          <input
            :style="{
              color: textColor || '#000000',
            }"
            style="width: 100%"
            type="text"
            ref="contactName"
            placeholder="Ex: Paulo Silva"
            @input="update()"
            class="answer-text"
          />
        </div>
      </template>

      <template v-if="contact === 'email'">
        <div class="answer">
          <input
            :style="{
              color: textColor || '#000000',
            }"
            type="email"
            style="width: 100%"
            ref="contactEmail"
            placeholder="Ex: nome@email.com"
            @input="update()"
            class="answer-text"
          />
        </div>
      </template>

      <template v-if="contact === 'phone'">
        <div class="answer">
          <input
            :style="{
              color: textColor || '#000000',
            }"
            type="text"
            style="width: 100%; margin-left: -15px"
            ref="contactPhone"
            placeholder="(19)-99999999"
            v-mask="'(##)-#########'"
            v-model="phoneNumber"
            @input="update()"
            class="answer-text"
          />
        </div>
      </template>
    </div>

    <hr />
  </div>
</template>

<script>
export default {
  name: 'contact',

  data() {
    return {
      phoneNumber: '',
    };
  },

  props: {
    textColor: { type: String, required: false },
    choices: { type: Array, required: true },
    questionText: { type: String, required: true },
    addQuestionTemplate: { type: String, required: true, default: 'default' },
    lang: { type: String, required: false, default: 'br' },
    name: { type: String, required: false },
    email: { type: String, required: false },
    phone: { type: String, required: false },
  },

  methods: {
    update() {
      this.$emit('input', {
        name: this.$refs.contactName ? this.$refs.contactName[0].value : null,
        email: this.$refs.contactEmail
          ? this.$refs.contactEmail[0].value
          : null,
        phone: this.$refs.contactPhone
          ? this.$refs.contactPhone[0].value
          : null,
      });
    },
    formatContact(contact) {
      let retStr = null;
      switch (contact) {
        case 'name':
          if (this.lang === 'br') {
            retStr = this.$t('researchPage.name');
          } else if (this.lang === 'us') {
            retStr = 'Name';
          } else {
            retStr = 'Nombre';
          }
          break;
        case 'email':
          if (this.lang === 'br') {
            retStr = this.$t('researchPage.email');
          } else if (this.lang === 'us') {
            retStr = 'Email';
          } else {
            retStr = 'Correo Electrónico';
          }
          break;
        case 'phone':
          if (this.lang === 'br') {
            retStr = this.$t('researchPage.phone');
          } else if (this.lang === 'us') {
            retStr = 'Phone';
          } else {
            retStr = 'Teléfono';
          }
          break;
        default:
          break;
      }
      return retStr;
    },
  },

  mounted() {
    if (this.choices.includes('name')) {
      this.$refs.contactName[0].value =
        this.name && this.name !== undefined ? this.name : '';
    }

    if (this.choices.includes('phone')) {
      this.$refs.contactPhone[0].value =
        this.phone && this.phone !== undefined ? this.phone : '';
    }

    if (this.choices.includes('email')) {
      this.$refs.contactEmail[0].value =
        this.email && this.email !== undefined ? this.email : '';
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.align-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-question {
  padding: 10px;
}

.answer {
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;

  & > * {
    margin-right: 8px;
  }

  .answer-text {
    flex-grow: 1;
  }

  input {
    background: transparent;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-bottom: 1px solid $gray;

    &:focus {
      outline: none;
      border-bottom: 1px solid $gray;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/contact/index.vue